// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-background {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.video-background .background-video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  transform: translate(-50%, -50%);
  object-fit: cover;
  z-index: -1;
}

.video-background::before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.479);
  position: absolute;
  top: 0;
  left: 0;
}

.generate-loading .message-box .container {
  background-color: rgba(0, 0, 0, 0.4);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/videoBackground.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AACF;AACE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iBAAA;EACA,WAAA;AACJ;;AAGA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAAF;;AAKI;EACE,oCAAA;AAFN","sourcesContent":[".video-background {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n\n  .background-video {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    min-width: 100%;\n    min-height: 100%;\n    transform: translate(-50%, -50%);\n    object-fit: cover;\n    z-index: -1;\n  }\n}\n\n.video-background::before {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.479);\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.generate-loading {\n  .message-box {\n    .container {\n      background-color: rgba(0, 0, 0, 0.4);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
